/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/constraints" DataTable endpoint.
 * Fetches paginated constraints (guardrails) and transforms the response
 * from the paginated API format into the standard DataTable format ({ hits, results }).
 */
import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdConstraints } from "./constants";
import type {
  ConstraintsApiResponse,
  DecisioningStudioAgentsAppGroupIdDsaIdConstraintsParams,
  GetDataTableDecisioningStudioAgentsAppGroupIdDsaIdConstraintsResult,
} from "./types";
import { isGetDataTableDecisioningStudioAgentsAppGroupIdDsaIdConstraintsResult } from "./validators";

export const getDataTableDecisioningStudioAgentsAppGroupIdDsaIdConstraints = reactQueryTableFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdConstraints,
  async (
    signal: AbortSignal,
    {
      appGroupId,
      dsaId,
      limit = 10,
      start = 0,
      environment,
    }: DecisioningStudioAgentsAppGroupIdDsaIdConstraintsParams
  ): Promise<GetDataTableDecisioningStudioAgentsAppGroupIdDsaIdConstraintsResult> => {
    const queryParams: Record<string, unknown> = { limit, start, environment };
    const rawResponse = await fetch<ConstraintsApiResponse>(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/constraints`,
      "GET",
      queryParams,
      { signal },
      { propagateFetchRequestError: false }
    );

    return {
      hits: rawResponse.meta.pagination.total ?? 0,
      results: rawResponse.data,
    };
  },
  isGetDataTableDecisioningStudioAgentsAppGroupIdDsaIdConstraintsResult
);
